import { t } from '../../lib/i18n';

/**
 * Şifre kuralları — ana süreçteki karşılığıyla aynı tutulmalı
 * (src/services/profileRules.ts). Şifre penceresi bu kuralları yazarken
 * canlı olarak işaretliyor.
 */

export const MIN_PASSWORD_LENGTH = 8;

export type PasswordRuleId = 'length' | 'uppercase' | 'lowercase' | 'digit';

export const PASSWORD_RULE_IDS: PasswordRuleId[] = ['length', 'uppercase', 'lowercase', 'digit'];

export function checkPasswordRules(password: string): Record<PasswordRuleId, boolean> {
  const value = typeof password === 'string' ? password : '';
  return {
    length: value.length >= MIN_PASSWORD_LENGTH,
    uppercase: /\p{Lu}/u.test(value),
    lowercase: /\p{Ll}/u.test(value),
    digit: /\d/.test(value),
  };
}

export function isPasswordStrong(password: string): boolean {
  return Object.values(checkPasswordRules(password)).every(Boolean);
}

export function passwordRuleLabel(rule: PasswordRuleId): string {
  switch (rule) {
    case 'length':
      return t(`En az ${MIN_PASSWORD_LENGTH} karakter`, `At least ${MIN_PASSWORD_LENGTH} characters`);
    case 'uppercase':
      return t('En az 1 büyük harf', 'At least 1 uppercase letter');
    case 'lowercase':
      return t('En az 1 küçük harf', 'At least 1 lowercase letter');
    case 'digit':
      return t('En az 1 rakam', 'At least 1 number');
  }
}
